import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Button, Col, message, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatDateTime, getOrderStatus } from 'helpers/format'
import { DetailReq, Product, UpdateReq, BestTrackingReq, ProductGrns } from 'Store/orders/types'
import { getOrderDetailAPI, updateOrderStatusAPI } from 'Store/orders/api'
import { selectActionEvent, selectDetail, selectDetailEvent } from 'Store/orders/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction, createBestTracking } from 'Store/orders/actions'
import EventModal from 'Components/modal/EventModal'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ConfirmDailog, ConfirmQuestion } from 'Components/modal'
import { ReciverInfo, PaymentInfo, DeliveryInfo, ProductsInfo } from './components'
import { DeliveryType, OrderStatus } from 'helpers/constanst'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { SelectedProductsGrn } from 'Store/stock/types'
import { selectIsPackageC } from 'Store/pos/selector'
import { selectProductsGrnList } from 'Store/stock/selector'
import { getStaffPermission } from 'helpers/account'
import ReturnDrawer from './components/ReturnDrawer'
import LinkText from 'Components/text/LinkText'
import ReturnOrderDrawer from 'Pages/OrderReturns/components/ReturnOrderDrawer'
import { RedoOutlined } from '@ant-design/icons'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: (status: OrderStatus) => void
  orderNo?: string
  status: OrderStatus
}

const CouponDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    orderNo = '',
    detail,
    status,
    detailEvent,
    //isPackageC,
    productsGrn,
  } = props

  const [statusUpdating, setStatusUpdating] = useState('' as OrderStatus)
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [confirmDialogPackageC, setConfirmDialogPackageC] = useState(false)
  const [rejectDialog, setRejectDialog] = useState(false)
  const [cancelDialog, setCancelDialog] = useState(false)
  const [showReturnDrawer, setShowReturnDrawer] = useState(false)
  const [showReturnHistoryDrawer, setShowReturnHistoryDrawer] = useState(false)
  const [bestWarningDialog, setBestWarningDialog] = useState(false)
  const [selectedGrn, setSelectedGrn] = useState([] as SelectedProductsGrn[])
  const dispatch = useDispatch()
  const shippingType = detail?.products[0]?.products[0]?.shipping_detail?.delivery_by || ''
  const isPublicDelivery = shippingType === DeliveryType.PUBLIC
  const isPackageC = detail?.products[0]?.package_level == '3'
  const permission = getStaffPermission()
  const hasReturnPermission = permission && permission.includes('create-order-returns')
  const isPos = detail?.channel === 'pos'
  const hasProduct: any =
    detail?.products &&
    detail?.products[0].products?.find(item => item?.quantity > (item?.product?.return_qty || 0))

  useEffect(() => {
    if (visible && orderNo !== '') {
      onGetDetail()
    }
    setShowReturnDrawer(false)
  }, [visible])

  const onGetDetail = (): void => {
    if (orderNo == '') return
    const req: DetailReq = {
      order_no: orderNo,
    }
    dispatch(getOrderDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const getProductIds = () => {
    const ids = [] as number[]
    detail?.products[0]?.products?.forEach((item: Product) => {
      ids.push(item?.id)
    })
    return ids
  }

  const formatProductGrnsReq = (): ProductGrns[] => {
    const req = [] as ProductGrns[]
    selectedGrn &&
      selectedGrn.forEach(item => {
        req.push({
          quantity: item.quantity,
          grn_item_ids: item.grn_item_ids,
        })
      })
    return req
  }

  const validateGrns = () => {
    let isValid = true
    //productsGrn
    selectedGrn &&
      selectedGrn.forEach(selected => {
        let count = 0
        const grnItem =
          productsGrn &&
          productsGrn.find(
            item =>
              item.product_id === selected.product_id &&
              item.product_option_id === selected.product_option_id,
          )

        if (grnItem) {
          grnItem.product_grn_items &&
            grnItem.product_grn_items.forEach(grn => {
              if (selected.grn_item_ids.includes(grn.item.id)) {
                count += grn.item.amount_system
              }
            })
        }
        if (count < selected.quantity) {
          isValid = false
          return
        }
      })
    return isValid
  }

  const hasGrnData = () => {
    let has = false
    productsGrn &&
      productsGrn.forEach(item => {
        if (item.product_grn_items && item.product_grn_items.length > 0) {
          has = true
          return
        }
      })
    return has
  }

  const onUpdateStatus = (status: OrderStatus, reason?: string): void => {
    const req: UpdateReq = {
      order_no: orderNo || '',
      product_ids: getProductIds(),
      status: status,
    }
    if (reason) {
      req.reason = reason
    }

    if (status === OrderStatus.CONFIRMED && isPackageC && hasGrnData()) {
      if (!validateGrns()) {
        message.error('ข้อมูล GRN สำหรับการตัดสินค้าออกจากสต๊อกไม่ถูกต้อง')
        setConfirmDialog(false)
        return
      }
      req.product_grns = formatProductGrnsReq()
    }

    dispatch(updateOrderStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onConfirmUpdateStatus = (status: OrderStatus, reason?: string): void => {
    if (status === OrderStatus.ON_DELIVERY && isPublicDelivery) {
      // For BEST Only need to create trcking number before update order status to OrderStatus.ON_DELIVERY
      onCreateBestTracking(status)
    } else {
      onUpdateStatus(status, reason)
    }
  }

  const onCreateBestTracking = (status: OrderStatus): void => {
    // Create tracking and auto update status to OrderStatus.ON_DELIVERY
    const req: BestTrackingReq = {
      merchant_id: currentUser?.activeMerchant?.id || 0,
      order_no: orderNo || '',
    }

    const reqUpdateStatus: UpdateReq = {
      order_no: orderNo || '',
      product_ids: getProductIds(),
      status: status,
    }

    dispatch(
      createBestTracking({
        token: currentUser.accessToken,
        xmid: currentUser?.activeMerchant?.uuid || '',
        createTracking: req,
        updateStatus: reqUpdateStatus,
      }),
    )
  }

  const onClickReject = (status: OrderStatus): void => {
    setStatusUpdating(status)
    setRejectDialog(true)
  }

  const onClickCancel = (status: OrderStatus): void => {
    setStatusUpdating(status)
    setCancelDialog(true)
  }

  const onClickReturn = (): void => {
    setShowReturnDrawer(true)
  }

  const onConfirmReject = (reason: string): void => {
    onUpdateStatus(statusUpdating, reason)
  }

  const onClickUpdateStatus = (status: OrderStatus): void => {
    setStatusUpdating(status)
    setConfirmDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess(statusUpdating)
    if (rejectDialog) {
      setRejectDialog(false)
    }
    if (confirmDialog) {
      setConfirmDialog(false)
    }
    if (cancelDialog) {
      setCancelDialog(false)
    }
  }

  const getFooter = (status: OrderStatus) => {
    const btn = [] as any[]
    btn.push(<PrimaryButton text="ปิด" btnType="Cancel" onClick={onCloseDrawer} />)
    switch (status) {
      case OrderStatus.SUCCESS:
        btn.push(
          <PrimaryButton
            key={`${status}-approve`}
            text="ยืนยันและเตรียมจัดส่ง"
            btnType="Approve"
            onClick={() => onClickUpdateStatus(OrderStatus.CONFIRMED)}
          />,
        )
        if (permission && permission.includes('cancel-order')) {
          btn.push(
            <PrimaryButton
              key={`${status}-reject`}
              text="ปฏิเสธ"
              btnType="Reject"
              onClick={() => onClickReject(OrderStatus.CANCEL)}
            />,
          )
        }

        break
      case OrderStatus.CONFIRMED:
        if (isPublicDelivery) {
          btn.push(
            <PrimaryButton
              key={`${status}-approve`}
              text="ดำเนินการจัดส่ง"
              btnType="Approve"
              onClick={() => onClickUpdateStatus(OrderStatus.ON_DELIVERY)}
            />,
          )
        } else {
          btn.push(
            <PrimaryButton
              key={`${status}-approve`}
              text="ดำเนินการจัดส่ง"
              btnType="Approve"
              onClick={() => onClickUpdateStatus(OrderStatus.ON_DELIVERY)}
            />,
          )
        }

        break
      case OrderStatus.ON_DELIVERY:
        btn.push(
          <PrimaryButton
            key={`${status}-approve`}
            text="จัดส่งสำเร็จ"
            btnType="Approve"
            onClick={() => {
              if (isPublicDelivery) {
                setBestWarningDialog(true)
              } else {
                onClickUpdateStatus(OrderStatus.DELIVERED)
              }
            }}
          />,
        )
        break
      case OrderStatus.PENDING:
        if (detail?.channel === 'pos') {
          btn.push(
            <PrimaryButton
              key={`${status}-reject`}
              text="ยกเลิกคำสั่งซื้อ"
              btnType="Reject"
              onClick={() => onClickCancel(OrderStatus.CANCEL)}
            />,
          )
        }

        break
      case OrderStatus.DELIVERED:
      case OrderStatus.CONFIRM_RECEICVED:
        if (detail?.channel === 'pos' && hasReturnPermission) {
          btn.push(
            <PrimaryButton
              key={`${status}-reject`}
              text="สร้างรายการรับคืนสินค้า"
              btnType="Reject"
              onClick={() => onClickReturn()}
              //disabled={!hasProduct}
            />,
          )
        }

        break
      default:
        break
    }

    return (
      <Space size="middle" align="baseline">
        {btn}
      </Space>
    )
  }

  const FooterContent = getFooter(status)

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title="ปฏิเสธรายการสั่งซื้อ"
      label="เหตุผลที่ปฏิเสธ"
      placeholder="เช่น สินค้าหมดไม่เพียงพอในการจัดส่ง..."
      confirmBtnTxt="ปฏิเสธ"
      isShow={rejectDialog}
      handleOk={(remark: string) => onConfirmReject(remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmCancelDailog = (
    <ConfirmQuestion
      title="ยกเลิกรายการสั่งซื้อ"
      label="เหตุผลที่ยกเลิกรายการสั่งซื้อ"
      placeholder="เช่น สินค้าหมดไม่เพียงพอในการจัดส่ง..."
      confirmBtnTxt="ยืนยัน"
      isShow={cancelDialog}
      handleOk={(remark: string) => onConfirmReject(remark)}
      handleCancel={() => setCancelDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title="ยืนยันการเปลี่ยนสถานะคำสั่งซื้อ"
      description={`คุณแน่ใจที่จะเปลี่ยนสถานะเป็น "${getOrderStatus(statusUpdating).text}" หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={() => onConfirmUpdateStatus(statusUpdating)}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmWithUpdtaeGrnDailog = (
    <ConfirmWithChild
      title={`ยืนยันเปลี่ยนสถานะคำสั่งซื้อเป็น "${getOrderStatus(statusUpdating).text}" หรือไม่`}
      child={<p>AAAA</p>}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialogPackageC}
      handleOk={() => {}}
      handleCancel={() => setConfirmDialogPackageC(false)}
      loading={event.IsLoading}
      width={'60%'}
    />
  )

  const BestWarningDailog = (
    <ConfirmDailog
      title="ไม่สามารถเปลี่ยนสถานะคำสั่งซื้อได้"
      description={`เนื่องจากคุณจัดส่งสินค้าโดย BEST Express ระบบจะทำการอัพเดทสถานะคำสั่งซื้อเป็น "สำเร็จ" ให้อัตโนมัติ หลังจากจัดส่งสินค้าไปยังลูกค้าสำเร็จ`}
      hasCancel={false}
      confirmBtnTxt="รับทราบ"
      isShow={bestWarningDialog}
      handleOk={() => setBestWarningDialog(false)}
      handleCancel={() => setBestWarningDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ReturnHistory = (
    <ReturnOrderDrawer
      isShow={showReturnHistoryDrawer}
      onClose={() => setShowReturnHistoryDrawer(false)}
      orderNo={detail?.order_no}
      onSuccess={() => onGetDetail()}
    />
  )

  const title = (
    <Row justify="space-between">
      <Col>
        <span>เลขที่สั่งซื้อ : {detail?.order_no} </span>
        <br />
        <InfoTitle>วันที่สั่งซื้อ : {formatDateTime(detail?.created_at || '')}</InfoTitle>
      </Col>
      <Col>
        {isPos && (status === OrderStatus.DELIVERED || status === OrderStatus.CONFIRM_RECEICVED) && (
          <Button type="text" onClick={() => setShowReturnHistoryDrawer(true)} danger>
            <RedoOutlined /> ประวัติการรับคืนสินค้า
          </Button>
        )}
      </Col>
    </Row>
  )

  const ReturnDrawerContent = (
    <ReturnDrawer
      visible={showReturnDrawer}
      onClose={() => setShowReturnDrawer(false)}
      detail={detail}
      onSuccess={() => {
        setShowReturnDrawer(false)
        onGetDetail()
      }}
    />
  )

  return (
    <DetailDrawer
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width="80%"
      maskClosable
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={16}>
        <Col md={24} xs={24}>
          <ProductsInfo
            detail={detail}
            orderNo={orderNo || ''}
            merchantId={currentUser?.activeMerchant?.id || 0}
            isPublicDelivery={isPublicDelivery}
            status={status}
            setSelectedGrn={setSelectedGrn}
            selectedGrn={selectedGrn}
          />
        </Col>
        <Col md={24} xs={24}>
          <DeliveryInfo detail={detail} status={status} />
        </Col>
        <Col md={12} xs={24}>
          <ReciverInfo detail={detail} status={status} onSuccess={onGetDetail} />
        </Col>
        <Col md={12} xs={24}>
          <PaymentInfo detail={detail} isViewMode={false} onSuccess={onGetDetail} />
        </Col>
      </Row>
      {ConfirmRejectDailog}
      {ConfirmApproveDailog}
      {BestWarningDailog}
      {ConfirmWithUpdtaeGrnDailog}
      {ConfirmCancelDailog}
      {isPos &&
        (status === OrderStatus.DELIVERED || status === OrderStatus.CONFIRM_RECEICVED) &&
        ReturnHistory}
      {isPos &&
        (status === OrderStatus.DELIVERED || status === OrderStatus.CONFIRM_RECEICVED) &&
        ReturnDrawerContent}
    </DetailDrawer>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detail: selectDetail(state),
    detailEvent: selectDetailEvent(state),
    isPackageC: selectIsPackageC(state),
    productsGrn: selectProductsGrnList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(CouponDetail)
